import { Link } from "react-router-dom";
import { GroqLogo } from "../common/GroqLogo";
import { SeelayLogo } from "../common/SeelayLogo";
import { SEELAY_URL } from "../../content/seelayBrand";

function Footer() {
  return (
    <footer className="site-footer w-full bg-muted/30 pt-12 font-[ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,'Segoe_UI',sans-serif]">
      <div className="mx-auto max-w-6xl px-4 pb-8 border-t border-border">
        <div className="flex h-[7rem] flex-col lg:flex-row items-start lg:items-center justify-between gap-4 lg:gap-6 pt-8">
          <p className="text-sm text-muted-foreground flex flex-wrap lg:flex-nowrap items-center gap-x-2 gap-y-1 shrink-0 max-w-full">
            Powered by
            <a
              href="https://developers.google.com/speed/docs/insights/v5/get-started"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 font-medium text-foreground hover:text-foreground transition-colors"
              style={{ fontFamily: '"Product Sans", Arial, sans-serif' }}
            >
              <img
                width={20}
                height={20}
                className="block h-5 w-5 shrink-0 object-cover object-center"
                src="/pagespeed.png"
                alt="PageSpeed"
              />
              PageSpeed
            </a>
            <span className="text-border">|</span>
            <a
              href="https://groq.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-2 font-medium text-foreground transition-colors"
            >
              <GroqLogo
                aria-label="Groq"
                className="h-5 w-[4.5rem] shrink-0"
              />
            </a>
          </p>
          <p className="flex flex-wrap lg:flex-nowrap items-center gap-x-1.5 gap-y-1 text-sm text-muted-foreground shrink-0">
            ©
            <a
              href={SEELAY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex shrink-0 items-center"
              style={{ width: 55, height: 12 }}
              aria-label="Seelay"
            >
              <SeelayLogo />
            </a>
            {new Date().getFullYear()} All rights reserved.
            <span className="text-border mx-1">|</span>
            <Link
              to="/privacy"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Privacy
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
